// Modal dialog functionality for role reset
// Converted from jQuery show/hide

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('reset-role-modal')

  if (!modal) return

  const modalForm = modal.querySelector('form')
  const cancelButton = modal.querySelector('.js-modal-cancel')

  // Handle reset role links
  document.querySelectorAll('.js-reset-role-link').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      const actionUrl = link.getAttribute('href')
      if (modalForm) {
        modalForm.setAttribute('action', actionUrl)
      }

      modal.classList.remove('hidden')
      modal.classList.add('show')
    })
  })

  // Handle cancel button
  if (cancelButton) {
    cancelButton.addEventListener('click', (e) => {
      e.preventDefault()
      modal.classList.add('hidden')
      modal.classList.remove('show')
    })
  }

  // Close on outside click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.classList.add('hidden')
      modal.classList.remove('show')
    }
  })
})
